(() => {
  if (window.__footerParallaxInit) return;
  window.__footerParallaxInit = true;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function initFooterParallax() {
    const footer = document.querySelector('[data-footer-parallax]');
    if (!footer) return;

    const footerSection =
      footer.closest('footer.section-wrapper') ||
      footer.closest('.shopify-section') ||
      footer.parentElement;

    if (!footerSection) return;

    const motionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

    let reduceMotion = motionMedia.matches;
    let isMobile = window.innerWidth < 750;

    let footerHeight = 0;
    let sectionTop = 0;
    let viewportHeight = window.innerHeight;

    let ticking = false;
    let rafId = null;

    let currentY = 0;
    let targetY = 0;

    // Ridotti su mobile per tenere Safari iOS più fluido
    const desktopStartOffset = 110;
    const desktopEndOffset = -60;

    const mobileStartOffset = 90;
    const mobileEndOffset = -45;

    // smoothing più leggero su desktop, più utile su iOS
    const desktopEase = 0.16;
    const mobileEase = 0.12;

    function getOffsets() {
      if (reduceMotion) return { start: 0, end: 0 };
      return isMobile
        ? { start: mobileStartOffset, end: mobileEndOffset }
        : { start: desktopStartOffset, end: desktopEndOffset };
    }

    function getEase() {
      return isMobile ? mobileEase : desktopEase;
    }

    function measure() {
      isMobile = window.innerWidth < 750;
      viewportHeight = window.innerHeight;

      // reset temporaneo per misurare bene
      footer.style.transform = 'translate3d(0, 0px, 0)';
      footerHeight = Math.ceil(footer.offsetHeight);

      footerSection.style.minHeight = `${footerHeight}px`;

      const rect = footerSection.getBoundingClientRect();
      sectionTop = rect.top + window.scrollY;

      updateTarget();
      currentY = targetY;
      applyTransform(currentY);
    }

    function updateTarget() {
      if (!footerHeight) return;

      const scrollY = window.scrollY || window.pageYOffset;
      const revealStart = sectionTop - viewportHeight;
      const rawProgress = (scrollY - revealStart) / footerHeight;
      const progress = clamp(rawProgress, 0, 1);

      const { start, end } = getOffsets();
      targetY = start + (end - start) * progress;
    }

    function applyTransform(value) {
      footer.style.transform = `translate3d(0, ${value.toFixed(2)}px, 0)`;
    }

    function animate() {
      rafId = null;

      updateTarget();

      const ease = getEase();
      currentY += (targetY - currentY) * ease;

      // snap finale per evitare micro-jitter
      if (Math.abs(targetY - currentY) < 0.1) {
        currentY = targetY;
      }

      applyTransform(currentY);

      if (Math.abs(targetY - currentY) >= 0.1) {
        rafId = requestAnimationFrame(animate);
      }
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        ticking = false;

        if (!rafId) {
          rafId = requestAnimationFrame(animate);
        }
      });
    }

    function measureAndUpdate() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }

      measure();
    }

    measureAndUpdate();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', measureAndUpdate, { passive: true });
    window.addEventListener('orientationchange', measureAndUpdate, { passive: true });
    window.addEventListener('load', measureAndUpdate);

    if (motionMedia.addEventListener) {
      motionMedia.addEventListener('change', (event) => {
        reduceMotion = event.matches;
        measureAndUpdate();
      });
    } else if (motionMedia.addListener) {
      motionMedia.addListener((event) => {
        reduceMotion = event.matches;
        measureAndUpdate();
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureAndUpdate).catch(() => {});
    }

    // ResizeObserver solo desktop/editor: su iOS può essere più rumoroso del necessario
    if ('ResizeObserver' in window && !isMobile) {
      const resizeObserver = new ResizeObserver(() => {
        measureAndUpdate();
      });
      resizeObserver.observe(footer);
    }

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', measureAndUpdate);
      document.addEventListener('shopify:section:reorder', measureAndUpdate);
      document.addEventListener('shopify:block:select', measureAndUpdate);
      document.addEventListener('shopify:block:deselect', measureAndUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterParallax);
  } else {
    initFooterParallax();
  }
})();